import { POIPrivateSticky } from './poi-private-sticky';

export default POIPrivateSticky;
